// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2cF_L","text":"SelectPayment_text__2ST3r","title":"SelectPayment_title__2BkHS","btn":"SelectPayment_btn__1izwX"};